export default function LoadingPage() {
    return (
        <div data-testid="loading-page">
            ...
        </div>
    );
}
